import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import './App.css';

export default function Payment(){
    const navigate = useNavigate();
    const location = useLocation();
    const {cusid,cusname,place,loanlist,custom} = location.state;
    const userid = parseInt(localStorage.getItem("userid")) ;
    const date = new Date().toISOString().slice(0,10);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const instamt = loanlist[0].InstallmentAmount;
    const [loanstatus,setLoanstatus] = useState([]);
    const [dueno, setDueno] = useState([]);
    const [dialogNo,setDialogNo] = useState(0);
    const [settings, setSettings] = useState([]);
    const [account, setAccount] = useState([]);
    const finddifference = (loanlist[0].LoanAmount - loanlist[0].LoanBalance) % instamt;

    var date1 = new Date().getTime()
    var date2 = new Date(loanlist[0].LoanDate).getTime();
    var daycount = parseInt((date1 - date2)/(1000*60*60*24));
    var findoverdue = loanlist[0].LoanAmount - daycount*instamt;
    console.log(daycount);
    console.log(findoverdue);
    console.log(loanlist[0].LoanBalance);
    console.log(loanlist[0].LoanBalance > findoverdue);
    console.log(6250 % 100);
  
  useEffect(() => {

    //fetch(API_URL+"api/Dayclosing/DayClosing?date="+ date)
    //.then(response => response.json()).then(data => {setClosedate(data)}); 

    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});

   // fetch(API_URL+"api/Payment/GetLastReceiptDate")
    //.then(response => response.json()).then(data => {setLrdate(data)}); 

    fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
    .then(res=>res.json())
    .then((data)=>{setSettings(data)})

     fetch(API_URL+"api/Userloan/GetLoanStatus?userid="+userid)
    .then(response => response.json())
    .then(data => {setLoanstatus(data)});

     fetch(API_URL+"api/Payment/GetDue?id="+ loanlist[0].LoanNo).then(response => response.json())
     .then(data => {setDueno(data)})},[])

     //console.log(receiptnum);
     //console.log(dueno);
     //console.log(loanstatus);
     //console.log(loanlist);
     
  function sleep(ms) 
  {
      return new Promise(resolve => setTimeout(resolve, ms));
  }

function makereceipt() 
{
  var amount = parseInt(document.getElementById('loPay').value);
  var paidlen = dueno.length > 0 ? dueno[0].Totaldue + 1 : 1;
  var balance = loanlist[0].LoanBalance;
  var rcnum = settings[0].ReceiptID + 1;
  var rdate = document.getElementById("doPay").value;
  var loanno = loanlist[0].LoanNo;
  var accno = loanlist[0].AccountNo;
  var famount = document.getElementById("fine").value;
  const commonid = settings[0].CommonID + 1

  if (loanstatus.length !== 0 )
  {
      if(loanstatus[0].LoanReturned === 1)
      {
        setDialogNo(1);
        showOKdialog();
      }
      else if(date < loanstatus[0].EntryDate.slice(0,10))
      {
        setDialogNo(2);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) > date)
      {
        setDialogNo(3);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) < date)
      {
        setDialogNo(4);
        showOKdialog();
      }
      else 
      {
        if (amount > 0)
        {
            const duecount = parseInt((amount + finddifference) / instamt);
            
            var a = ((daycount-1)*instamt - (loanlist[0].LoanAmount-balance));
            
            var lbalance = parseFloat(balance - amount);

            const data = new FormData();
            data.append("rnum",rcnum);
            data.append("rdate",rdate);
            data.append("loanno",loanno);
            data.append("accountnumber",accno);
            data.append("ramount",amount);
            data.append("rdueno", duecount >= 1 ? paidlen : (paidlen-1));
            data.append("adddue", duecount >= 1 ? (duecount - 1) : duecount)
            data.append("totaldue",duecount >= 1 ? paidlen + duecount - 1 : (paidlen - 1 + duecount))
            data.append("lbalance",lbalance);
            data.append("cid",cusid);
            data.append("cname",cusname);
            data.append("rfine",famount);
            data.append("commonid",commonid)
            data.append("userid",userid);
            data.append("overdueamount", (a <= 0 ? 0 : (amount >= a ? a : amount)));

            fetch(API_URL+"api/Payment/PaymentReceipt",{method:"POST",body:data})
            .then(response=>response.json())
            .then(()=>{});

            fetch(API_URL+"api/Payment/UpdateLoan?installmentpaid="+(duecount >= 1 ? paidlen + duecount - 1 : (paidlen - 1 + duecount))+"&loanbalance="+lbalance+"&lreceiptdate="+rdate+"&id="+loanlist[0].LoanNo,{method:"PUT",body:null})
              .then(response => response.json())
              .then(()=>{});


          /*else
          {
                          
              const data = new FormData();
              data.append("rnum",rcnum);
              data.append("rdate",rdate);
              data.append("loanno",loanno);
              data.append("ramount",amount);
              data.append("rdueno",paidlen-1);
              data.append("adddue",duecount)
              data.append("totaldue",paidlen - 1 + duecount)
              data.append("lbalance",lbalance);
              data.append("cid",cusid);
              data.append("cname",cusname);
              data.append("rfine",famount);
              data.append("commonid",commonid)
              data.append("userid",userid);

              fetch(API_URL+"api/Payment/PaymentReceipt",{method:"POST",body:data})
              .then(response=>response.json())
              .then(()=>{});

              
          }*/

              fetch(API_URL+"api/Payment/IncrementReceiptID?id="+rcnum,{method:"PUT",body:null})
              .then(res=>res.json())
              .then(()=>{});

              
        
          if(lbalance === 0)
          {
              fetch(API_URL+"api/Loan/LoanClosing?id="+ loanlist[0].LoanNo,{method:"PUT",body:null})
              .then(response => response.json())
              .then(() =>{});

              setDialogNo(5);
              showOKdialog();
          }
          else
          {
              setDialogNo(5);
              showOKdialog();
          }
          

          if(famount > 0)
          {
              var finetransid = settings[0].FineTransID + 1;
              const fine = new FormData();
              fine.append("fdate",rdate);
              fine.append("famount",famount);
              fine.append("loanno",loanno);
              fine.append("accountnumber",accno);
              fine.append("rnum",rcnum);
              fine.append("userid",userid);
              fine.append("transid",finetransid);
              fine.append("commonid",commonid);
              

            fetch(API_URL+"api/Fine/CreateFine",{method:"POST",body:fine}).then(response=>response.json())
            .then(()=>{});

            fetch(API_URL+"api/Ledger/UpdateFineTransID?id="+ finetransid,{method:"PUT",body:null})
            .then(response=>response.json())
            .then(()=>{});
          }
          
        }
        else
        {
          setDialogNo(7);
          showOKdialog();
        }
      }
      
  }
  else 
  {
    setDialogNo(6);
    showOKdialog();
  }
  
}

function ledgerentry()
{
  
  
  const amount =parseFloat(document.getElementById('loPay').value);
  var dueCount= parseInt((amount + finddifference) / instamt);
  var totaldue = dueno.length > 0 ? dueno[0].Totaldue : 0;
  const duenum = totaldue + dueCount 
    
    var transid = settings[0].AccTransID + 1;
    const commonid = settings[0].CommonID + 1

    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    var cashbalance = (cashaccount[0].CurrentDebit+amount)-cashaccount[0].CurrentCredit;
    
    const cashaccountdata = new FormData();

    cashaccountdata.append("entrydate",date);
    cashaccountdata.append("accountdate",date)
    cashaccountdata.append("accountid",cashaccount[0].AccountID)
    cashaccountdata.append("description", "By Loan Account  Loan No ("+loanlist[0].LoanNo+")");
    cashaccountdata.append("refnumber",("L.NO "+loanlist[0].LoanNo));
    cashaccountdata.append("vouchertype",1);
    cashaccountdata.append("vouchernum",1);
    cashaccountdata.append("dramount",amount);
    cashaccountdata.append("cramount",0);
    cashaccountdata.append("balance",cashbalance);
    cashaccountdata.append("transid",transid);
    cashaccountdata.append("commonid",commonid);
    cashaccountdata.append("userid",userid);


    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:cashaccountdata})
    .then(response=>response.json())
    .then(()=>{});


    const loanaccount = account.filter((e)=>{if(e.AccountID === 4){return e;}})
    const loanaccbalance = loanaccount[0].CurrentDebit - (loanaccount[0].CurrentCredit+amount);
    
    const loanaccountdata = new FormData();
    transid = transid + 1;

    loanaccountdata.append("entrydate",date);
    loanaccountdata.append("accountdate",date)
    loanaccountdata.append("accountid",loanaccount[0].AccountID)
    loanaccountdata.append("description", "To Cash Account  Loan No ("+loanlist[0].LoanNo+")");
    loanaccountdata.append("refnumber",("L.NO "+loanlist[0].LoanNo));
    loanaccountdata.append("vouchertype",1);
    loanaccountdata.append("vouchernum",1);
    loanaccountdata.append("dramount",0);
    loanaccountdata.append("cramount",amount);
    loanaccountdata.append("balance",loanaccbalance);
    loanaccountdata.append("transid",transid);
    loanaccountdata.append("commonid",commonid);
    loanaccountdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:loanaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+loanaccount[0].AccountID+"&amount="+(loanaccount[0].CurrentCredit+amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});
    
    const fineamount = parseFloat(document.getElementById('fine').value);
    transid = transid + 1;
    if (fineamount > 0)
    {
      cashbalance = (cashaccount[0].CurrentDebit+amount+fineamount)-cashaccount[0].CurrentCredit;
      loanaccountdata.set("accountid",cashaccount[0].AccountID);
      loanaccountdata.set("dramount", fineamount);
      loanaccountdata.set("cramount",0);
      loanaccountdata.set("balance",cashbalance);
      loanaccountdata.set("transid",transid);
      loanaccountdata.set("description", "By Fine Account  Loan No ("+loanlist[0].LoanNo+")");

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:loanaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    const fineaccount = account.filter((e)=>{if(e.AccountID === 6){return e;}})
    const fineaccbalance = fineaccount[0].CurrentDebit - (fineaccount[0].CurrentCredit+fineamount);
    transid = transid + 1;
    loanaccountdata.set("accountid",fineaccount[0].AccountID);
    loanaccountdata.set("dramount", 0);
    loanaccountdata.set("cramount",fineamount);
    loanaccountdata.set("balance",fineaccbalance);
    loanaccountdata.set("transid",transid);
    loanaccountdata.set("description", "To Cash Account  Loan No ("+loanlist[0].LoanNo+")");

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:loanaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+fineaccount[0].AccountID+"&amount="+ (fineaccount[0].CurrentCredit+fineamount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});
    }

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit+amount+fineamount) ,{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateAccTransID?id="+transid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});


    const loanledgerdata = new FormData();
    const loanbalance = loanlist[0].LoanBalance - parseFloat(amount);
    const loantransid = settings[0].LoanTransID + 1;
    var loanno = loanlist[0].LoanNo;
    var accno = loanlist[0].AccountNo;

    loanledgerdata.append("entrydate",date);
    loanledgerdata.append("description",dueCount > 1 ? "To Loan no:"+loanno+" Due No " + "("+(totaldue +1) +"-"+duenum+")" : "By Loan no:"+loanno+" Due No " + "("+duenum+")" );
    loanledgerdata.append("dramount",amount);
    loanledgerdata.append("cramount",0);
    loanledgerdata.append("balance",loanbalance);
    loanledgerdata.append("transid",loantransid);
    loanledgerdata.append("commonid",commonid);
    loanledgerdata.append("loanno",loanno);
    loanledgerdata.append("accountnumber",accno);
    loanledgerdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/LoanLedgerEntry",{method:"POST",body:loanledgerdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateLoanTransID?id="+loantransid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCommonID?id="+commonid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});


}
    
    

{/*function loanupdate()
{
   
  fetch(API_URL+"api/Payment/UpdateLoan?id="+ loanlist[0].LoanNo,{method:"put",body:null})
  .then(response => response.json())
  .then(()=>{});
        
}*/}

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}
        
return (
        <>
        <div>
            <div style = {{height:"30px", width:"100%",paddingTop:"10px",paddingLeft:"10px",backgroundColor:"blue",color:"white",textAlign:"left"}}>Payment</div>
            <Navbar/>
            <fieldset>
            <label for = "idNum">Customer</label><br />
            <input type = "text" value ={cusname} id = "idNum" className="inputfield"  ></input><br/> <br/>
            
            <label for ="loNum">Loan Number</label><br/>
            <input type = 'text' id ='loNum' value ={loanlist[0].LoanNo} className="inputfield"></input><br/><br/>
            
            <label for ="loBal">Balance</label><br/>
            <input type = 'text' id ='loBal' value = {loanlist[0].LoanBalance} className="inputfield"></input><br/><br/>
            
            <label for = 'doPay'>Date Of Payment </label><br/>
            <input id = 'doPay' value = {date} type = "date"  className="inputfield" readOnly/><br/><br/>
            
            <label for ="loPay">Paying Amount </label><br/>
            <input type = 'text' id ='loPay' defaultValue= {loanlist[0].InstallmentAmount} className="inputfield"></input><br/><br/>
            
            <label for ="fine">Fine Amount </label><br/>
            <input type = 'text' id ='fine' defaultValue="0"  className="inputfield"></input><br/><br/>
            
            <div>
            <button type = "button"  className="actionbuttons" onClick={()=>{makereceipt()}}>Payment</button>
            <button type = "button"  className="actionbuttons" style ={{backgroundColor:"red"}} onClick={()=>{navigate('/actions', {state:{cusid,cusname,place,custom}})}}>Back</button>
            </div>
            </fieldset>
        </div>
        <dialog id="myDialog" className="okdialog">
            {dialogNo === 1 ? <>
            <p>Collection Closed For this User ID : {userid}  </p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 2 ? <>
            <p>Please Make Sure, Payment Date is Correct</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 3 ? <>
            <p>Sorry! You Can't Make Payments for Today's Date As Your Day closed</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 4 ? <>
            <p>Sorry! Please Make Sure Last Day Collection Settlement is Over</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 5 ? <>
            <p>Payment Entry Successful</p>
            <button className="okdialogbutton" onClick={()=>{ledgerentry();navigate('/home');}}>OK</button> </> : <></>}
            {dialogNo === 6 ? <>
            <p>Please Ask Approval For Payment Collection</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 7 ? <>
            <p>Please Make Sure Payment is More Than Rs.0</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
        </dialog> 
        </>
      )
    }


